import React from 'react';
import EmptyState from "./ui/EmptyState";

export default function SkillsList() {
    return (
        <div>
            <header className="page-head reveal">
                <span className="page-eyebrow">Skills</span>
                <h1 className="page-title-mt">Skill Tracker</h1>
                <p className="page-sub">View and track skills here.</p>
            </header>

            <div className="card-mt reveal reveal-d1">
                <EmptyState
                    icon="layers"
                    title="Skill tracking is coming soon"
                    text="This area will let you browse and track skills across the organisation. In the meantime, manage your own skills from the Skill Performance Dashboard."
                />
            </div>
        </div>
    );
}
